import createReducer from 'Lib/createReducer';

export const RESET_READER = 'RESET_READER';
export const SAVE_BOOK_PAGE_BREAK = 'SAVE_BOOK_PAGE_BREAK';
export const SAVE_EBOOK = 'SAVE_EBOOK';
export const SAVE_SCROLL_CFI = 'SAVE_SCROLL_CFI';
export const SAVE_URL_PARAMS = 'SAVE_URL_PARAMS';
export const SAVE_IS_MOBILE = 'SAVE_IS_MOBILE';
export const HIDE_PAGE_SELECTOR = 'HIDE_PAGE_SELECTOR';


const initialState = {
  currentCfi: '',
  currentPageBreak: '',
  ebook: {
    cfi: '',
    vbid: '',
    start: '',
    stop: ''
  },
  fromSnippetExit: false,
  isMobile: false,
  isSnippet: false,
  redirectOrigin: '',
  showPageSelector: true
};

const reader = createReducer(initialState, {
  [RESET_READER]: (state, action) => {
    const { ebook } = state;
    const reset = {
      currentCfi: '',
      currentPageBreak: '',
      isSnippet: false,
      ebook: {
        ro: ebook.ro,
        vbid: ebook.vbid
      },
      fromSnippetExit: true
    };

    return { ...state, ...reset };
  },

  [SAVE_BOOK_PAGE_BREAK]: (state, action) => {
    return { ...state, currentPageBreak: action.data };
  },

  [SAVE_EBOOK]: (state, action) => {
    return { ...state, ebook: action.data, fromSnippetExit: false };
  },

  [SAVE_SCROLL_CFI]: (state, action) => {
    return { ...state, currentCfi: action.data.cfi };
  },

  [SAVE_URL_PARAMS]: (state, action) => {
    const { isMobile, data } = action.data;
    const isSnippet = !!data.start;

    return { ...state, ebook: data, isMobile, isSnippet };
  },

  [SAVE_IS_MOBILE]: (state, action) => {
    return { ...state, isMobile: !state.isMobile };
  },

  [HIDE_PAGE_SELECTOR]: (state, action) => {
    return { ...state, showPageSelector: false };
  }
});


export default reader;
